import angular from 'angular';
import _ from 'lodash';
import stampit from 'stampit';
import EventEmitter from 'utility/event-emitter';
import { RealtimeRole } from '@doxyme/og-realtime';
import { setApolloSessionStorageData } from 'utility/sessionStorage/actions';
import doctorRealtimeActionsModule from './doctor-realtime-actions.module';
import patientRealtimeActionsModule from './patient-realtime-actions.module';
import { EndCallReasons } from '../../common/services/doxy-analytics/tracks/video-session-end';
import { RootScopeEvents } from '../../common/services/root-scope-types';
import { MediaModes } from '../../providers/video/abstract-video-provider';
import { BetaFlags, hasBetaFeature, hasGrowthBookFeature, GrowthBookFeatures, } from '../../modules/core';
import { CallNotifications } from '../../video-chat/video-chat.realtime-component';
import { hideSidebarIfMobile } from '../../modules/core/actions';
export default angular
    .module('doxy.realtime.components', [
    patientRealtimeActionsModule,
    doctorRealtimeActionsModule,
])
    .factory('RealtimeComponent', function (pn, $rootScope, $modal, $log, $timeout) {
    return stampit({
        props: {
            userState: pn.globalState,
            pn,
        },
        deepProps: {
            mediator: null,
            events: {},
            innerMediatorEvents: {},
            state: {},
            initiator: null,
            initialState: null,
        },
        methods: {
            async send(uuid, action, content) {
                return pn.send(uuid, {
                    componentName: this.componentName,
                    action,
                    content,
                });
            },
            onCallHold() {
                if (Boolean(this._onCallHold)) {
                    return this._onCallHold();
                }
                return this.reset();
            },
            onCallEnd() {
                if (Boolean(this._onCallEnd)) {
                    return this._onCallEnd();
                }
                return this.reset();
            },
            onLeave(person) {
                if (Boolean(this._onLeave)) {
                    this._onLeave(person);
                }
            },
            onMessage(message, person) {
                const { requestAck, messageId, action, content } = message;
                this.mediator.emit(action, content, person, {
                    requestAck,
                    messageId,
                });
            },
            sendTo(uuid, action, content) {
                this.send(uuid, action, content);
            },
            sendToTarget(action, content) {
                this.send(this.target.uuid, action, content);
            },
            hideModal() {
                if (Boolean(this.modal)) {
                    this.modal.hide();
                }
                (this.$scope ?? $rootScope).$emit('modal.hide');
            },
            openModal(data) {
                if (Boolean(this.openModalTimeout)) {
                    $timeout.cancel(this.openModalTimeout);
                }
                const hideTimeout = Boolean(this.modal?.$isShown) ? 500 : 0;
                this.hideModal();
                if (Boolean(data.contentTemplate)) {
                    data.contentTemplate = `${this.basePath}${data.contentTemplate}`;
                }
                if (Boolean(data.template)) {
                    data.template = `${this.basePath}${data.template}`;
                }
                this.openModalTimeout = $timeout(() => {
                    this.modal = $modal(_.extend({
                        scope: this.$scope,
                        backdrop: 'static',
                    }, data));
                }, hideTimeout);
            },
            createInnerMediator() {
                this.innerMediator = new EventEmitter();
                // eslint-disable-next-line unicorn/no-array-reduce
                const listeners = Object.keys(this.innerMediatorEvents).reduce((obj, event) => {
                    const action = this[this.innerMediatorEvents[event]];
                    if (!Boolean(action)) {
                        $log.error(`${this.innerMediatorEvents[event]} doesnt exists`);
                    }
                    obj[event] = action.bind(this);
                    return obj;
                }, {});
                this.innerMediator.addListeners(listeners);
            },
            createScope(props = []) {
                this.$scope = $rootScope.$new(true);
                _.extend(this.$scope, _.pick(this, props));
            },
        },
        init(opts) {
            Object.assign(this, opts);
            this.mediator = new EventEmitter();
            // eslint-disable-next-line unicorn/no-array-reduce
            const listeners = Object.keys(this.events).reduce((obj, event) => {
                const action = this[this.events[event]];
                if (!Boolean(action)) {
                    $log.error(`${this.events[event]} doesnt exists`);
                }
                obj[event] = action.bind(this);
                return obj;
            }, {});
            this.mediator.addListeners(listeners);
        },
    });
})
    .factory('activeComponents', function ($injector) {
    const constructors = {
        phone: 'VideoChatRealtimeComponent',
        chat: 'TextChatRealtimeComponent',
    };
    const ActiveComponents = stampit({
        methods: {
            create: function (name, ...args) {
                const construct = _.isString(constructors[name])
                    ? $injector.get(constructors[name])
                    : constructors[name];
                this[name] = construct.apply(construct, args);
            },
            remove(name) {
                this[name] = null;
            },
            getComponent(componentName) {
                return this[componentName];
            },
            createComponent(data) {
                if (!Boolean(this[data.componentName])) {
                    if (Boolean(data.moduleName)) {
                        $injector.loadNewModules([data.moduleName]);
                    }
                    if (Boolean(data.componentName)) {
                        this[data.componentName] = $injector
                            .get(data.serviceName)
                            .create({ activeComponents: this });
                    }
                    else {
                        console.error('ActiveComponents.createComponent: invalid data', data);
                    }
                }
                return this[data.componentName];
            },
        },
        init() {
            this.create('chat');
        },
    });
    return ActiveComponents.create();
})
    .factory('randomError', function (notificationFactory) {
    return function () {
        const errorNum = Math.floor(Math.random() * 4) + 1;
        const randomMessage = `random-error-${errorNum}`;
        notificationFactory.showCommon('error', randomMessage);
    };
})
    .factory('communicationControl', function ($window, $timeout, $state, globalUi, activeComponents, $log, notificationFactory, pn, LoopBackAuth, $rootScope, randomError, intercomFactory, VideoProviderFactory, Browser, youtubeService, $stateParams, trackingFactory, currentUserHelper, institutionHelper, roomHelpersFactory, v2, callQualitySurveyService) {
    async function _clearVideoState() {
        return new Promise((resolve) => {
            if (!Boolean(activeComponents.phone) ||
                !Boolean(VideoProviderFactory.activeProvider.isSessionConnected())) {
                resolve();
                return;
            }
            activeComponents.phone.endVideo({
                notification: CallNotifications.Hold,
            });
            void $timeout(resolve, 1000);
        });
    }
    function checkMedia(target) {
        if (!Boolean(target.state.hasMic)) {
            notificationFactory.showCommon('warning', 'target-no-mic');
        }
        if (!Boolean(target.state.hasCamera)) {
            notificationFactory.showCommon('warning', 'target-no-video');
        }
    }
    const isMissingMedia = (person) => {
        return pn.globalState.onlyChat || person.state.onlyChat;
    };
    const showMissingMediaError = (person) => {
        const messagePrefix = pn.globalState.onlyChat ? 'you' : 'target';
        const message = `${messagePrefix}-missing-media`;
        const articleUrl = pn.globalState.onlyChat
            ? Browser.getHelpArticleUrl()
            : 'https://help.doxy.me/en/articles/95877-allow-access-to-camera-mic';
        notificationFactory.showCommon('error', message, null, null, {
            articleUrl,
            username: person.state.username,
        });
    };
    const removeFromWaitingRoom = async (person, notificationMessage) => {
        pn.forceRemove(person);
        VideoProviderFactory.activeProvider.forceDisconnectPerson(person);
        return pn.send(person.uuid, {
            componentName: 'global',
            action: 'removedFromWaitingRoom',
            content: {
                notificationMessage,
            },
        });
    };
    const MAX_CALL_RESTART_ATTEMPTS = 5;
    const CommunicationControl = stampit({
        deepProps: {
            callRestartAttempts: null,
        },
        methods: {
            async phoneStart(person, tempConfig) {
                const config = {
                    options: {},
                    ...tempConfig,
                };
                $rootScope.$emit(RootScopeEvents.COMMUNICATION_CONTROL.PHONE_START, person);
                config.options.autoDowngradeQuality =
                    $rootScope.globalState.beta[BetaFlags.AutoDowngradeQuality];
                config.options.ipWhiteList =
                    $rootScope.globalState.beta[BetaFlags.IpWhitelist];
                config.options.mobileGroupUI =
                    hasBetaFeature(BetaFlags.MobileGroupUI) ||
                        hasGrowthBookFeature(GrowthBookFeatures.MobileGroupUI);
                this.callRestartAttempts = 0;
                // Hide survey immediately when starting a call to prevent race condition
                // where the survey from the previous call shows up before session init
                callQualitySurveyService.hide();
                hideSidebarIfMobile();
                if (Browser.isMobileScreen()) {
                    activeComponents.chat.toggleChat(false);
                }
                if (Boolean(activeComponents.chat.minimized)) {
                    this.openChat(person, false);
                }
                if (Boolean(pn.globalState.badUser)) {
                    console.error(randomError());
                    return;
                }
                if (Boolean(person.activeVideo) ||
                    person.state.status === 'video') {
                    return;
                }
                if (v2.isEnabled()) {
                    checkMedia(person);
                    const isAudioCall = config.options.audioOnly;
                    await _clearVideoState.call(this);
                    activeComponents.create('phone', config);
                    const referrer = window.location.pathname;
                    const patientId = person.uuid;
                    trackingFactory.global.trackButtonClick({
                        button_text: 'Start Call',
                        button_action: 'Start Apollo call',
                        button_type: 'button',
                        context: 'sidebar',
                    });
                    const chatHistory = activeComponents.chat.history;
                    setApolloSessionStorageData({
                        referrer,
                        patientId,
                        role: RealtimeRole.Provider,
                        vendor: 'Vonage',
                        navigationStarted: Date.now(),
                        rooms: roomHelpersFactory.getPersonalRooms(),
                        roomId: person.roomId.toString(),
                        chatHistory,
                        identityId: pn.getUuid(),
                        subscriptionType: currentUserHelper.getSubscriptionType(),
                        institutionsMembershipsIds: currentUserHelper.getInstitutionsMembershipsIds(),
                        institutionId: institutionHelper.getCurrentInstitutionId(),
                        profileInfo: {
                            firstName: currentUserHelper.user.firstName,
                            lastName: currentUserHelper.user.lastName,
                            profilePictureUrl: currentUserHelper.getProfilePictureUrl(),
                        },
                        userId: currentUserHelper.user.id,
                        patientPlatform: Boolean(person.mobileBrowser)
                            ? 'mobile'
                            : 'web',
                        isAudioCall,
                    });
                    void pn.stop();
                    intercomFactory.shutdown();
                    void v2.redirect('/call');
                }
                else {
                    checkMedia(person);
                    await _clearVideoState.call(this);
                    const isRoutedSession = Boolean($rootScope.globalState.beta[BetaFlags.RoutedSession]);
                    const mediaMode = isRoutedSession
                        ? MediaModes.ROUTED
                        : MediaModes.RELAYED;
                    activeComponents.create('phone', config);
                    await activeComponents.phone.start({ person, mediaMode });
                    intercomFactory.shutdown();
                    if (Boolean(isMissingMedia(person))) {
                        showMissingMediaError(person);
                    }
                    $stateParams.force = true;
                    $state.go('account.dashboard', { force: $stateParams.force });
                }
            },
            phoneStop(notification) {
                $rootScope.$emit(RootScopeEvents.COMMUNICATION_CONTROL.PHONE_STOP);
                if (!Boolean(activeComponents.phone)) {
                    return;
                }
                activeComponents.phone.endVideo({ notification });
                activeComponents.remove('phone');
                intercomFactory.reboot();
                const isHold = notification === CallNotifications.Hold;
                for (const activeComponent of Object.values(activeComponents)) {
                    if (!Boolean(activeComponent)) {
                        continue;
                    }
                    const action = 
                    // Note: We are not convinced that the strict boolean check is accurate, in that the IRealtimeComponent type is not correct.
                    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, @typescript-eslint/strict-boolean-expressions
                    (isHold
                        ? // Note: We also need to ignore the unbound method because the `this` context is coming from the parent.
                            // eslint-disable-next-line @typescript-eslint/unbound-method
                            activeComponent.onCallHold
                        : // eslint-disable-next-line @typescript-eslint/unbound-method
                            activeComponent.onCallEnd) || activeComponent.reset;
                    if (_.isFunction(action)) {
                        action.call(activeComponent);
                    }
                    if (!Boolean(activeComponent)) {
                        continue;
                    }
                }
                $rootScope.$emit('tcPagedDocument:clear');
            },
            canBeSwitchedToRoutedMediaMode(newPeople) {
                const people = [
                    ...newPeople,
                    ...VideoProviderFactory.activeProvider.peopleCollection.models,
                ];
                return !people.some((person) => !Boolean(person.supportsRoutedSessions()));
            },
            async switchToRoutedForAudioType() {
                const loaderMessage = 'session.call-restart';
                const endCallReason = EndCallReasons.RESTART_FOR_AUDIO_TYPE;
                await this.switchToRoutedSessionIfPossible([], loaderMessage, endCallReason);
            },
            async switchToRoutedForGroupCall(newPeople) {
                const loaderMessage = 'session.call-switch-to-routed';
                const endCallReason = EndCallReasons.RESTART_FOR_GROUP;
                await this.switchToRoutedSessionIfPossible(newPeople, loaderMessage, endCallReason);
            },
            async switchToRoutedSessionIfPossible(newPeople, loaderMessage, endCallReason) {
                if (VideoProviderFactory.activeProvider.callSession.mediaMode !==
                    MediaModes.ROUTED &&
                    Boolean(this.canBeSwitchedToRoutedMediaMode(newPeople))) {
                    $rootScope.$emit('video-chat-loading-screen:update-message', loaderMessage);
                    $rootScope.$emit('activeProvider:endReason', endCallReason);
                    await this.doRestartCall(MediaModes.ROUTED, null, loaderMessage);
                }
            },
            phoneInvite(target, joinToken) {
                if (!Boolean(activeComponents.phone)) {
                    return;
                }
                activeComponents.phone.invitePerson({
                    person: target,
                    joinToken,
                    mediaMode: VideoProviderFactory.activeProvider.callSession.mediaMode,
                });
                if (VideoProviderFactory.activeProvider.callSession.mediaMode ===
                    MediaModes.ROUTED &&
                    Boolean(target.state.system) &&
                    target.state.system.browser === 'safari' &&
                    target.state.system.browserVersion <= 12) {
                    console.warn('Invite in routed mode: Safari 12 or older detected');
                }
            },
            addPersonToGroupCallByUid(uuid) {
                const person = pn.people.findByUid(uuid);
                this.addToGroupCall(person);
            },
            async addToGroupCall(target) {
                const people = Array.isArray(target) ? target : [target];
                for (const person of people) {
                    person.startVideo();
                }
                try {
                    await this.switchToRoutedForGroupCall(people);
                    const data = await VideoProviderFactory.activeProvider.addParticipantsToSession(people);
                    for (const person of people) {
                        this.phoneInvite(person, data.joinTokens.find((joinToken) => joinToken.identityId === person.uuid)?.token);
                    }
                    hideSidebarIfMobile();
                }
                catch {
                    for (const person of people) {
                        person.endVideo();
                    }
                }
            },
            async answerPhone(message, person) {
                if (Boolean(person.activeVideo)) {
                    return;
                }
                person.startVideo();
                this.phoneStop(CallNotifications.Hold);
                $rootScope.$emit(RootScopeEvents.COMMUNICATION_CONTROL.ANSWER_PHONE, person);
                $rootScope.$emit(RootScopeEvents.DOKBOT.DOXYBOT_PRECALL_TEST_CANCEL);
                checkMedia(person);
                globalUi.toggleVideo(true);
                if (!globalUi.ui.isRestartingCall) {
                    globalUi.set({ screenSharing: false });
                }
                if (Browser.isMobileScreen()) {
                    activeComponents.chat.toggleChat(false);
                }
                callQualitySurveyService.hide();
                notificationFactory.playSound('waitingfor');
                activeComponents.create('phone', { options: message.options });
                await activeComponents.phone
                    .join({ message, person })
                    .catch($log.error.bind($log, 'joinVideo'));
                intercomFactory.shutdown();
                youtubeService.exitFullscreen();
                youtubeService.pauseVideo();
            },
            openChat(target, condition) {
                activeComponents.chat.openChat(target, condition);
            },
            async remove(target) {
                let message = 'removedFromWaitingRoom';
                if (hasGrowthBookFeature(GrowthBookFeatures.Voyce) &&
                    target.state.pid === 'voyce') {
                    message = 'interpreterCallEnded';
                }
                return removeFromWaitingRoom(target, message);
            },
            removeByUuid(uuid) {
                const person = pn.people.findByUid(uuid);
                return this.remove(person);
            },
            async removeEveryoneOnCall() {
                if (!Boolean(activeComponents.phone)) {
                    return;
                }
                const removePromises = VideoProviderFactory.activeProvider.peopleCollection.models.map(async (p) => {
                    let message = 'callEnded';
                    if (hasGrowthBookFeature(GrowthBookFeatures.Voyce) &&
                        p.state.pid === 'voyce') {
                        message = 'interpreterCallEnded';
                    }
                    return removeFromWaitingRoom(p, message);
                });
                try {
                    await Promise.all(removePromises);
                }
                finally {
                    this.phoneStop();
                }
            },
            forceDisconnect(target) {
                if (Boolean(activeComponents.phone)) {
                    activeComponents.phone.forceDisconnect(target);
                }
            },
            startTeleconsent() {
                // Mobile apps are no longer supported, so this check is no longer needed
            },
            async restartCall(mediaMode = VideoProviderFactory.activeProvider.callSession
                .mediaMode) {
                if (this.callRestartAttempts >= MAX_CALL_RESTART_ATTEMPTS) {
                    notificationFactory.showCommon('info', 'call-restart-limit', 'call-restart-limit', 15000);
                    return;
                }
                this.callRestartAttempts++;
                $rootScope.$emit('video-chat-loading-screen:update-message', 'session.call-restart');
                await this.doRestartCall(mediaMode, null, 'session.call-restart');
            },
            async doRestartCall(mediaMode, notification, loaderMessage) {
                const currentSession = VideoProviderFactory.activeProvider.callSession;
                const mainSessionId = currentSession.mainSessionId ?? currentSession.id;
                $rootScope.$emit(RootScopeEvents.COMMUNICATION_CONTROL.DO_RESTART);
                const people = _.clone(VideoProviderFactory.activeProvider.peopleCollection.models);
                const options = Boolean(activeComponents.phone.options)
                    ? _.clone(activeComponents.phone.options)
                    : {};
                options.applyLastConfig = true;
                globalUi.ui.isRestartingCall = true;
                await activeComponents.phone.requestVideoRestart(notification, loaderMessage);
                globalUi.startCall();
                activeComponents.remove('phone');
                callQualitySurveyService.hide();
                activeComponents.create('phone', { options });
                await activeComponents.phone.start({
                    person: people.shift(),
                    mediaMode,
                    mainSessionId,
                });
                if (people.length > 0) {
                    const data = await VideoProviderFactory.activeProvider.addParticipantsToSession(people);
                    for (const person of people) {
                        person.startVideo();
                        activeComponents.phone.sendInvite({
                            person,
                            joinToken: data.joinTokens.find((joinToken) => joinToken.identityId === person.uuid)?.token,
                        });
                    }
                }
            },
        },
    });
    return CommunicationControl.create();
}).name;
